import * as React from "react";
import styled from "styled-components";
import AssigneeCell from "security-app/components/common/AssigneeCell";
import useUsersAndTeams from "security-app/components/Investigations/hooks/useUsersAndTeams";
const Container = styled.div`
  display: flex;
  gap: 5px;
`;
const Assignee = ({ assigneeId }) => {
  const usersAndTeams = useUsersAndTeams();
  const assignee = usersAndTeams[assigneeId];
  if (!assignee) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(AssigneeCell, { assignee }));
};
export default Assignee;
